/**
 * The given `orderResponseSchema` / `disputeResponseSchema` contract has no field linking
 * an order to its dispute in either direction (no `disputeId` on the order, no list-by-order
 * endpoint for disputes). As a stopgap, we remember the mapping locally (non-sensitive
 * internal UUIDs only) whenever we learn it — from creating a dispute or opening one by ID —
 * so the order detail page can deep-link to it in the same browser. This is best-effort, not
 * authoritative; if apps/api adds `disputeId` to `OrderResponse`, remove this.
 */
const STORAGE_KEY = "hybrid-escrow:dispute-links";

function readMap(): Record<string, string> {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Record<string, string>) : {};
  } catch {
    return {};
  }
}

export function rememberDisputeForOrder(orderId: string, disputeId: string): void {
  try {
    const map = readMap();
    map[orderId] = disputeId;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // Best-effort only; ignore storage failures (private browsing, quota, etc).
  }
}

export function getDisputeIdForOrder(orderId: string): string | null {
  return readMap()[orderId] ?? null;
}
